import { IAnalyticsAsset } from '../Player/Player'
import React, { useEffect, useState } from 'react'
import {
  BannerWrapper,
  DynamicColumnsWrapper,
  LeftRailItem,
  LeftRailItemCredit,
  LeftRailItemImage,
  LeftRailItemLink,
  LeftRailItemSeparator,
  LeftRailItemTitle,
  LeftRailItemTitleCreditContainer,
  PlayerBGWrapper,
  PlayerWrapper,
  TaboolaColumn,
  Title,
} from './LiveChanelPlayer.style'
import { OttTaboolaMidLiveWidget } from '../../AdsComponents'
import { ILastAiredItem } from '../../../types'
import { BreadCrumbs } from '../BreadCrumbs/BreadCrumbs'
import Link from '../../../components/Link/Link'
import { useOttOverlay } from '../../../contexts'
import { IConfigFile } from '../../../utils'
import dynamic from 'next/dynamic'

const TopBanner = dynamic(
  () => import('../../../components/Ads/TopBanner/TopBanner'),
  { ssr: false }
)
const Player = dynamic(() => import('../Player/Player'), { ssr: false })

export interface PlayerPropsState {
  background: string
  desktopLogo: string
  mobileLogo?: string
  assetData: IAnalyticsAsset | null
  fetched: boolean
  isCatchup: boolean | null
  isTrailer: boolean | null
  isMovie: boolean | null
}

export const LiveChanelPlayer = ({
  MEDIAID,
  playerProps,
  configFile,
}: {
  MEDIAID: string
  playerProps: PlayerPropsState
  configFile: IConfigFile
}) => {
  const { assetData } = playerProps
  const { assetMeta } = useOttOverlay()
  const [lastAiredFetched, setLastAiredFetched] = useState<boolean>(false)
  const [lastAired, setLastAired] = useState<ILastAiredItem[] | null>(null)

  const fetchLastAired = async () => {
    try {
      setLastAiredFetched(false)
      const res = await fetch('/cdn/last_aired.json')
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`)
      }
      const data: ILastAiredItem[] = await res.json()
      setLastAired(data)
      setLastAiredFetched(true)
    } catch (err) {
      console.error('Error loading last aired:', err)
    }
  }

  const formatDate = (dateStr: string): string => {
    const date = new Date(dateStr.replace(' ', 'T')) // ensure proper ISO parsing
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    return `${day}.${month}, ${hours}:${minutes}`
  }

  useEffect(() => {
    if (!lastAiredFetched) {
      fetchLastAired()
    }
  }, [lastAiredFetched])

  return (
    <>
      {/*<Head>*/}
      {/*  <title>{assetData?.name}</title>*/}
      {/*</Head>*/}
      <BannerWrapper>
        <TopBanner key={'TopBanner'} isVod={true} />
      </BannerWrapper>
      <BreadCrumbs
        configFile={configFile}
        crumbList={[{ name: assetMeta?.title || '' }]}
      />
      <DynamicColumnsWrapper>
        <PlayerWrapper>
          <PlayerBGWrapper>
            {assetData && (
              <Player
                key={MEDIAID}
                MEDIAID={MEDIAID}
                HOUSE={assetData.house || ''}
                POSTER={playerProps.background}
                REFERENCE_ID={assetData.referenceId || ''}
                DURATION={assetData?.duration || 0}
                entryId={assetData?.entryId || ''}
              />
            )}
          </PlayerBGWrapper>
          <Title>{configFile?.live_h_title}</Title>
        </PlayerWrapper>
        <TaboolaColumn>
          {lastAired &&
            Object.entries(lastAired)
              .slice(0, 3)
              .map((item, index) => {
                const date = item[1].publishDate
                  ? formatDate(item[1].publishDate)
                  : ''
                return (
                  <React.Fragment key={index}>
                    <LeftRailItemLink href={item[1].link}>
                      <LeftRailItem>
                        <LeftRailItemImage src={item[1].img} />
                        <LeftRailItemTitleCreditContainer>
                          <LeftRailItemTitle>{item[1].title}</LeftRailItemTitle>
                          <LeftRailItemCredit>
                            <Link href={item[1].writer[0].link}></Link>
                            {item[1].writer[0].name} | {date}
                          </LeftRailItemCredit>
                        </LeftRailItemTitleCreditContainer>
                      </LeftRailItem>
                    </LeftRailItemLink>
                    <LeftRailItemSeparator
                      src={
                        'https://media3.reshet.tv/image/upload/v1742385545/uploads/2025/904509791.webp'
                      }
                    />
                  </React.Fragment>
                )
              })}
        </TaboolaColumn>
      </DynamicColumnsWrapper>
      <OttTaboolaMidLiveWidget />
    </>
  )
}
